module.exports = __webpack_public_path__ + "static/media/thumb1.4cf7a9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/thumb1.jpg
// module id = 640
// module chunks = 0